import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const WORKSPACES_API_URL = "https://tu-api.com/workspaces";
const REPORTS_API_URL = "https://tu-api.com/reports";

export default function AdminWorkspaces({ show, onClose }) {
  const [workspaces, setWorkspaces] = useState([]);
  const [reports, setReports] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState("");
  const [selectedReport, setSelectedReport] = useState("");

  useEffect(() => {
    if (show) {
      fetchWorkspaces();
    }
  }, [show]);

  const fetchWorkspaces = async () => {
    const response = await axios.get(WORKSPACES_API_URL);
    setWorkspaces(response.data);
  };

  const fetchReports = async (workspaceId) => {
    const response = await axios.get(`${REPORTS_API_URL}?workspaceId=${workspaceId}`);
    setReports(response.data);
  };

  const handleWorkspaceChange = (e) => {
    const workspaceId = e.target.value;
    setSelectedWorkspace(workspaceId);
    fetchReports(workspaceId);
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Administración de Workspaces y Reportes</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Seleccionar Workspace:</label>
              <select
                className="form-select"
                value={selectedWorkspace}
                onChange={handleWorkspaceChange}
              >
                <option value="">Seleccione un Workspace</option>
                {workspaces.map((ws) => (
                  <option key={ws.id} value={ws.id}>{ws.name}</option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Seleccionar Reporte:</label>
              <select
                className="form-select"
                value={selectedReport}
                onChange={(e) => setSelectedReport(e.target.value)}
              >
                <option value="">Seleccione un Reporte</option>
                {reports.map((report) => (
                  <option key={report.id} value={report.id}>{report.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
}